import React from 'react';
import { Box, Button } from '@chakra-ui/react';
import SectionTitle from '../../components/shared/SectionTitle';

const HeroContent = () => (
  <Box color="white" mt="10">
    <SectionTitle
      noPadding
      title="Goodbye, tape measures. Hello, accuracy in 3D."
      subTitle="Get the only app that combines to the inch measurements with an
        interactive 3D model."
      link={
        <Button
          as="a"
          size="lg"
          mt="7"
          href="https://calendly.com/hover-sdr/hover-architect"
          target="_blank"
          whiteSpace="normal"
          minW="100%"
        >
          Schedule Time with Sales to Learn More
        </Button>
      }
    />
  </Box>
);
export default HeroContent;
